import AddIcon from '@atlaskit/icon/core/add';
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import entryIcon from '../../assets/entry_icon.svg';
import { messages } from '../../i18n';

import { DatabaseEntryPickerOptionContainer } from './databaseEntryPicker.styles';

export interface DatabaseEntryPickerOptionProps {
  isCreate: boolean;
  label: string;
}

const DatabaseEntryPickerOption: FunctionComponent<DatabaseEntryPickerOptionProps> = ({
  isCreate,
  label,
}) => {
  const { formatMessage } = useIntl();

  return (
    <DatabaseEntryPickerOptionContainer>
      {isCreate ? (
        <AddIcon
          size="small"
          label={formatMessage(messages['reference-entry-picker-option.add-icon-label'])}
        />
      ) : (
        <img src={entryIcon} />
      )}
      {label}
    </DatabaseEntryPickerOptionContainer>
  );
};

export default DatabaseEntryPickerOption;
